import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { Button } from "@pentabd/ui";

import { ErrorModal } from "@components";
import DetailsForm from "./DetailsForm";
import ProductsTable from "./ProductsTable";
import SelectedProductsTable from "./SelectedProductsTable";

import {
  RequisitionDetailsResponseType,
  RequisitionProductDataType,
} from "@type/inventory/requisition-details";
import useActionCreator from "../../../../redux/hooks/useActionCreator";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { REQUSITION_STATUS } from "@constants/status.inventory";
import { AssetType } from "@type/inventory/asset";

type Props = {
  handleProductsRemove: (id: number | string) => void;
  showAssignButtonHandler: (data: boolean) => void;
  approveOrRejectHandler: (type: boolean) => void;
  handleProcessProduct: any;
  data: RequisitionDetailsResponseType | null;
  selectedProducts: any;
};

export const RequisitionDetailsBody = ({
  handleProductsRemove,
  showAssignButtonHandler,
  selectedProducts,
  approveOrRejectHandler,
  handleProcessProduct,
  data,
}: Props) => {
  const { t } = useTranslation();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const [modifyData, setModifyData] = useState<
    RequisitionProductDataType[] | []
  >(data?.data || []);

  const [status, setStatus] = useState<string>(data?.status || "");

  const [isStockErrorModalOpen, setIsStockErrorModalOpen] =
    useState<boolean>(false);

  const closeErrorModal = () => {
    setIsStockErrorModalOpen(false);
  };

  const { approveRequisition } = useActionCreator();
  const { id } = useParams();

  const handleApprovedAmount = (obj: AssetType, amount: string) => {
    if (amount > obj.stock) {
      setIsStockErrorModalOpen(true);
    } else {
      setModifyData((prev) =>
        prev.map((asset) => {
          if (asset.id === obj.id) {
            return {
              ...asset,
              approvedAmount: Number(amount),
            };
          } else {
            return {
              ...asset,
            };
          }
        }),
      );
    }
  };

  const submitForm = (type: string) => {
    // !!!
    let sendData: { data: Array<any> } = { data: [] };

    if (type === "APPROVE") {
      const __modifyData = modifyData.map((item) => {
        return {
          nameId: item.nameId,
          requestAmount: item.requestAmount,
          approvedAmount: item.approvedAmount
            ? item.approvedAmount
            : item.stock < item.requestAmount
            ? item.stock
            : item.requestAmount,
        };
      });
      sendData = { data: __modifyData };
      approveOrRejectHandler(true);
    } else {
      sendData = { data: [] };
      approveOrRejectHandler(false);
    }

    approveRequisition(id || "", sendData);
  };

  useEffect(() => {
    setModifyData(data?.data || []);
    setStatus(data?.status || "");
  }, [data]);

  useEffect(() => {
    let show = modifyData?.some((item) => !item.isAssign);
    showAssignButtonHandler(show ? true : false);
  }, [modifyData]);

  return (
    <div className="mt-10">
      {/* <InfoCards /> */}
      {/* <WorkFlow /> */}
      <DetailsForm data={data} />

      {selectedProducts && selectedProducts.length > 0 && (
        <ProductsTable
          handleProductsRemove={handleProductsRemove}
          selectedProducts={selectedProducts}
        />
      )}

      <SelectedProductsTable
        status={status}
        data={modifyData}
        handleApprovedAmount={handleApprovedAmount}
        handleProcessProduct={handleProcessProduct}
      />

      {/* <Application data={data} /> */}

      {/* <Comments /> */}

      <div className="text-end border-top pt-10">
        {getAccess(roles, "REQUISITION_APPROVE") &&
        status !== REQUSITION_STATUS.APPROVED &&
        status !== "REJECTED" ? (
          <>
            <Button
              fill="fill"
              type="danger"
              size="xs"
              className="me-5"
              onClick={(e) => {
                submitForm("REJECT");
              }}
            >
              {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.REJECT")}
            </Button>
            <Button
              fill="fill"
              type="primary"
              size="xs"
              onClick={(e) => {
                submitForm("APPROVE");
              }}
            >
              {t("INVENTORY_REQUISITION.REQUISITION_DETAILS.APPROVE")}
            </Button>
          </>
        ) : (
          <></>
        )}

        {/* <Button
          fill="outline"
          type="primary"
          size="xs"
          htmlType="submit"
          onClick={() => {
            console.log("modifyData: ", modifyData);
            submitForm();
          }}
          className="me-5"
        >
          Save
        </Button>
        <Button
          fill="fill"
          type="primary"
          size="xs"
          onClick={() => {
            console.log("send for approval clicked ");
          }}
        >
          Send For Approval
        </Button> */}
      </div>
      {isStockErrorModalOpen && (
        <ErrorModal
          isModalOpen={isStockErrorModalOpen}
          closeModal={closeErrorModal}
          title="Not enough item/asset in stock"
        />
      )}
    </div>
  );
};
